import { render, staticRenderFns } from "./LapLamp7D.vue?vue&type=template&id=7a283fe8"
import script from "./LapLamp7D.vue?vue&type=script&lang=js"
export * from "./LapLamp7D.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports